import React from "react";
import { Link } from "react-router-dom";
import gray from "../images/PARAGON-9.jpg";
import yellow from "../images/PARAGON-15.jpg";

const newSport = [
  {
    id: "gray",
    name: "BEIGE/GRAY PAREΛGON RUNNERS",
    price: "$300 USD",
    img: gray,
  },
  {
    id: "yellow",
    name: "YELLOW PAREΛGON RUNNER 860",
    price: "$300 USD",
    img: yellow,
  },
];

const Sport = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 font-sans text-center">
      <h1 className="text-3xl font-bold mb-10 uppercase tracking-wide">Sport</h1>
      <div className="flex justify-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-2xl w-full">
          {newSport.map((product) => (
            <Link key={product.id} to={`/product/${product.id}`} className="block text-center">
              <img
                src={product.img}
                alt={product.name}
                className="w-full h-64 object-contain mb-3"
              />
              <p className="text-base font-medium">{product.name}</p>
              <p className="text-sm font-bold text-gray-800 mt-1">{product.price}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sport;
